import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-table-page-ui',
    templateUrl: './bb-table-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbTablePageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
